export default __webpack_public_path__ + "static/media/QR.127c8b59.gif";